import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const submitTwoFactorAuthWidgetStart = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_START`,
  (password: string) => ({ password })
);

export const submitTwoFactorAuthWidgetStartSuccess = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_START_SUCCESS`,
  (secretUrl: string, secret: string) => ({ secretUrl, secret })
);

export const submitTwoFactorAuthWidgetStartFailure = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_START_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const submitTwoFactorAuthWidgetVerifyAuthenticator = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_VERIFY_AUTHENTICATOR`,
  (code: string) => ({ code })
);

export const submitTwoFactorAuthWidgetVerifyAuthenticatorSuccess = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_VERIFY_AUTHENTICATOR_SUCCESS`,
  (recoveryCodes: string[]) => ({ recoveryCodes })
);

export const submitTwoFactorAuthWidgetVerifyAuthenticatorFailure = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_VERIFY_AUTHENTICATOR_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);

export const submitTwoFactorAuthWidgetRegenerateRecoveryCodes = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_REGENERATE_RECOVERY_CODES`,
  (password: string) => ({ password })
);

export const submitTwoFactorAuthWidgetRegenerateRecoveryCodesSuccess =
  createAction(
    `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_REGENERATE_RECOVERY_CODES_SUCCESS`,
    (recoveryCodes: string[]) => ({ recoveryCodes })
  );

export const submitTwoFactorAuthWidgetRegenerateRecoveryCodesFailure =
  createAction(
    `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_REGENERATE_RECOVERY_CODES_FAILURE`,
    (errorMessage: string) => ({ errorMessage })
  );

export const submitTwoFactorAuthWidgetReset = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_RESET`,
  (password: string) => ({ password })
);

export const submitTwoFactorAuthWidgetResetSuccess = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_RESET_SUCCESS`,
  () => ({})
);

export const submitTwoFactorAuthWidgetResetFailure = createAction(
  `${reduxKey}.SUBMIT_TWOFACTORAUTH_WIDGET_RESET_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
